import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import { AuctionProvider } from './contexts/AuctionContext';
import Navbar from './components/navbar';
import Hero from './components/Hero';
import AddCar from './pages/AddCar';
import Auth from './pages/Auth';
import CarDetail from './pages/CarDetail';
import PrivateRoute from './components/PrivateRoute';
import UserDetails from './pages/UserDetails';
import MyAccount from './pages/MyAccount';
import HomePage from './pages/HomePage';
import Auctions from './pages/Auctions';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <Router>
      <AuthProvider>
        <AuctionProvider>
          <ErrorBoundary>
            <div className="App">
              <Navbar />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/auctions" element={<Auctions />} />
              <Route path="/user-details" element={<UserDetails />} />
              <Route path="/my-account" element={<MyAccount />} />
              <Route 
                path="/pridat-auto" 
                element={
                  <PrivateRoute>
                    <AddCar />
                  </PrivateRoute>
                } 
              />
              <Route path="/car/:id" element={<CarDetail />} />
              <Route 
                path="/profile" 
                element={
                  <PrivateRoute>
                  </PrivateRoute>
                } 
              />
            </Routes>
            <Footer />
          </div>
          </ErrorBoundary>
        </AuctionProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;

